module.exports = __webpack_public_path__ + "img/question-option.2af691fd.png";